import { render, staticRenderFns } from "./BarWidgetChart.vue?vue&type=template&id=20e408ca"
import script from "./BarWidgetChart.vue?vue&type=script&lang=js"
export * from "./BarWidgetChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports